import { useRef, type PointerEvent } from 'react'
import { closeDialog } from './dialogMotion'

/** Dismiss only when both ends of a pointer gesture are on the backdrop. */
export function useBackdropDismiss(busy = false) {
  const startedOutside = useRef(false)
  function outside(e: PointerEvent<HTMLDialogElement>) {
    const r = e.currentTarget.getBoundingClientRect()
    return e.target === e.currentTarget &&
      (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)
  }
  return {
    onPointerDown(e: PointerEvent<HTMLDialogElement>) {
      startedOutside.current = e.button === 0 && outside(e)
    },
    onPointerUp(e: PointerEvent<HTMLDialogElement>) {
      const dismiss = startedOutside.current && outside(e)
      startedOutside.current = false
      if (dismiss && !busy) void closeDialog(e.currentTarget)
    },
    onPointerCancel() { startedOutside.current = false },
  }
}
